import { differenceInMonths, parseISO } from 'date-fns';
import { LOCAL_STORAGE } from '../config/constants';
import { Budget, BudgetStatus, Registration, Transaction } from '../types';

export default function determineBudgetStatus(
  budgets: Budget[],
  transactions?: Transaction[] | null,
  registrations?: Registration[] | null,
  currentDate: Date = new Date()
): BudgetStatus {
  const currentMonth = currentDate.getMonth() + 1;
  const lastBudget = parseISO(budgets[budgets.length - 1]?.date);
  const monthsSinceLastBudget = differenceInMonths(lastBudget, currentDate);

  const neverBudgeted = !budgets.length;
  const hasNotBudgetedRecently = Math.abs(monthsSinceLastBudget) >= 2;
  const hasNotBudgetedThisMonth = currentMonth > lastBudget.getMonth() + 1;
  const hasUntrackedTransactions = transactions?.length;
  const hasTenOrMoreUntrackedTransactions =
    transactions && transactions.length >= 10;
  const isBankConnectEnabled = registrations?.length;
  const previouslyDismissedBankConnect = window.localStorage.getItem(
    LOCAL_STORAGE.SKIP_BANK_CONNECT
  );

  // Budgets
  if (neverBudgeted) {
    return BudgetStatus.NeverBudgeted;
  }

  if (hasNotBudgetedRecently) {
    return BudgetStatus.NeglectedBudget;
  }

  if (hasNotBudgetedThisMonth) {
    return BudgetStatus.NewMonth;
  }

  // Untracked Transactions
  if (transactions && hasUntrackedTransactions) {
    if (hasTenOrMoreUntrackedTransactions) {
      return BudgetStatus.TrackTransactions10Plus;
    } else {
      return BudgetStatus.TrackTransactions;
    }
  }

  // Bank Connect
  if (registrations) {
    if (!isBankConnectEnabled && !previouslyDismissedBankConnect) {
      return BudgetStatus.ConnectBank;
    }

    return BudgetStatus.CaughtUp;
  }

  return BudgetStatus.Default;
}
